var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#32CCCC",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 16.3803C10.6667 11.2918 14.7918 7.16667 19.8804 7.16667C24.9689 7.16667 29.094 11.2918 29.094 16.3803V22.9615C29.094 24.4154 27.9154 25.594 26.4616 25.594H23.8291C23.1021 25.594 22.5128 25.0047 22.5128 24.2778V19.0128C22.5128 18.2859 23.1021 17.6966 23.8291 17.6966H27.1197V16.3803C27.1197 12.3822 23.8785 9.14103 19.8804 9.14103C15.8822 9.14103 12.641 12.3822 12.641 16.3803V17.6966H15.9316C16.6586 17.6966 17.2479 18.2859 17.2479 19.0128V24.2778C17.2479 25.0047 16.6586 25.594 15.9316 25.594H13.2992C13.0719 25.594 12.8514 25.5652 12.641 25.5111L12.641 25.9231C12.641 27.4905 13.8588 28.7736 15.3998 28.8778L15.6026 28.8846L17.087 28.8856C17.4933 27.7348 18.5905 26.9103 19.8804 26.9103C21.516 26.9103 22.8419 28.2362 22.8419 29.8718C22.8419 31.5074 21.516 32.8333 19.8804 32.8333C18.591 32.8333 17.4941 32.0094 17.0875 30.8593L15.6026 30.859C12.9645 30.859 10.8098 28.7894 10.6735 26.1852L10.6667 25.9231V16.3803Z",
    fill: "#32CCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon8);
export default __webpack_public_path__ + "static/media/icon8.b84d9e7031841d76f5d97cf556cea2d9.svg";
export { ForwardRef as ReactComponent };